import type { Language } from '@seek/melways-sites';

const defaultSiteTitle = 'Account Settings | SEEK Australia';

const siteTitles: Record<string, string> = {
  'candidate-seek-au-en': 'Account Settings | SEEK Australia',
  'candidate-seek-nz-en': 'Account Settings | SEEK New Zealand',
  'candidate-jobsdb-hk-en': 'Account Settings | Jobsdb Hong Kong',
  'candidate-jobsdb-th-en': 'Account Settings | Jobsdb Thailand',
  'candidate-jobsdb-th-th': 'การตั้งค่าบัญชีผู้ใช้ | Jobsdb ประเทศไทย',
  'candidate-jobstreet-sg-en': 'Account Settings | Jobstreet Singapore',
  'candidate-jobstreet-id-en': 'Account Settings | Jobstreet Indonesia',
  'candidate-jobstreet-id-id': 'Pengaturan Akun | Jobstreet Indonesia',
  'candidate-jobstreet-ph-en': 'Account Settings | Jobstreet Philippines',
  'candidate-jobstreet-my-en': 'Account Settings | Jobstreet Malaysia',
  'candidate-au-en': 'Account Settings | SEEK Australia',
  'candidate-nz-en': 'Account Settings | SEEK New Zealand',
  'candidate-hk-en': 'Account Settings | JobsDB Hong Kong',
  'candidate-th-en': 'Account Settings | JobsDB Thailand',
  'candidate-th-th': 'การตั้งค่าบัญชีผู้ใช้ | JobsDB ประเทศไทย',
  'candidate-sg-en': 'Account Settings | Jobstreet Singapore',
  'candidate-id-en': 'Account Settings | Jobstreet Indonesia',
  'candidate-id-id': 'Pengaturan Akun | Jobstreet Indonesia',
  'candidate-ph-en': 'Account Settings | Jobstreet Philippines',
  'candidate-my-en': 'Account Settings | Jobstreet Malaysia',
};

export default (
  site: string = 'candidate-seek-au',
  language: Language = 'en',
): string => siteTitles[`${site}-${language}`] || defaultSiteTitle;
